import React,{useState,useEffect} from 'react'
import axios from './axios';
import request from './request';
import './Banner.css'
const Banner = () => {
const [movie,setMovie]=useState([]) ;

useEffect( () => {
  async function fetchData() {
   const req= await axios.get(request.fetchNetflixOriginals);
   setMovie(
   req.data.results[
    Math.floor(Math.random()*req.data.results.length-1)
  ]
   );
   return req;
}
fetchData();
},[]);
console.log(movie);
  return (
    <header className='banner' style={{
      backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
    }}>
        <div className='banner_contents'>
         <h1 className='banner_title'>{movie?.name || movie?.title || movie?.original_name}</h1>
        <div className='banner_buttons'>
          <button className='banner_button'>Play</button>
          <button className='banner_button'>MyList</button>
        </div>
        <h1 className='banner_description'>{movie?.overview}</h1>
        </div>
       
    </header>
    
  )
}

export default Banner